import {
  GetAttributesToManageProps,
  userAttributesFromEndpointProps
} from './types';

/**
 * @param userAttributes
 * @param userAttributesToManage
 * @returns object with user attributes based on the userAttributesToManage array
 */

export const getAttributesToManage = ({
  modifiedUserAttributes,
  managedAttributes
}: GetAttributesToManageProps) => {
  const attributesToMange = managedAttributes.reduce(
    (filteredObject, attribute) => {
      if (attribute in modifiedUserAttributes) {
        filteredObject[attribute] = modifiedUserAttributes[attribute];
      }
      return filteredObject;
    },
    {}
  );

  return attributesToMange;
};

/**
 * structure data recieved from user-details endpoint
 * @param userAttributes
 * @returns an object with userAttrubutes.name as the key and userAttributes.value as the value
 */
export const structureUserAttributesData = (
  userAttributes: userAttributesFromEndpointProps
) => {
  const attributes = userAttributes.reduce((prev, curr) => {
    prev[curr.name] = curr.value;
    return prev;
  }, {});

  return attributes;
};
